// removed by extract-text-webpack-plugin
module.exports = {"Modal":"EmailListModal__-loca-__2WZQC","CloseButton":"EmailListModal__-loca-__3a6En"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/EmailListModal/EmailListModal.css
// module id = 222
// module chunks = 0